<template>
    <div>
        <router-view v-if="$route.name !== 'EUServicesList'"></router-view>
        <EUServicesList v-else></EUServicesList>
    </div>
</template>
<script>
import EUServicesList from "@/views/gekko/EUServicesList";
  
export default {
    name: "EUServicesHome",
    components: {EUServicesList, }
}
</script>